import { ContainerAccessors, ContainerUtils, ContainerValidators } from '../engine/Container';
import { ItemUtils } from '../engine/Item';
import { rulesEngineSelectors } from '../selectors';
import { ItemManager } from './ItemManager';
import { MessageManager } from './MessageManager';
export class ContainerManager extends MessageManager {
    constructor(params) {
        super(params);
        this.getContainerItem = () => {
            const item = ContainerAccessors.getItem(this.container);
            return item ? this.generateItemManager(item) : null;
        };
        // get the items from a list of items...
        // this logic needs to be consolidated in the incentory manager via
        // the filter logic
        /**
         * TODO IMS: filtering and sorting as params then no need to inventory to be passed
         * @returns Array<ItemManager>
         */
        this.getInventoryItems = ({ filteredInventory, includeContainer, }) => {
            const allItems = rulesEngineSelectors.getAllInventoryItems(this.state);
            const items = ContainerUtils.getInventoryItems(this.container, filteredInventory ? filteredInventory : allItems);
            if (includeContainer) {
                const containerItem = ContainerAccessors.getItem(this.container);
                if (containerItem) {
                    items.push(containerItem);
                }
            }
            return ItemUtils.sortInventoryItems(items, includeContainer).map((item) => this.generateItemManager(item));
        };
        // TODO should we make a new one that has coin? or rework the current one?
        // generateCoinManager = () => {
        //     return new CoinManager()
        // }
        // Accessors
        this.getDefinitionKey = () => ContainerAccessors.getDefinitionKey(this.container);
        this.getMappingId = () => ContainerAccessors.getMappingId(this.container);
        this.getName = () => ContainerAccessors.getName(this.container);
        this.isShared = () => ContainerAccessors.isShared(this.container);
        this.getWeightInfo = () => ContainerAccessors.getWeightInfo(this.container);
        this.isEquipped = () => ContainerAccessors.isEquipped(this.container);
        this.hasInfusions = () => ContainerAccessors.hasInfusions(this.container);
        this.getCoin = () => ContainerAccessors.getCoin(this.container);
        // Validators
        this.isCharacterContainer = () => ContainerValidators.isCharacterContainer(this.container);
        // Static Helpers ... not sure I like this but this might be better?
        // static isSharedContainerDefinitionKey = (state, containerDefinitionKey: string) => {
        //     const containerLookup = rulesEngineSelectors.getContainerLookup(state);
        //     return ContainerValidators.validateIsShared(containerDefinitionKey, containerLookup);
        // };
        this.isSharedOtherContainerDefinitionKey = (otherContainerDefinitionKey) => {
            const containerLookup = rulesEngineSelectors.getContainerLookup(this.state);
            return ContainerValidators.validateIsShared(otherContainerDefinitionKey, containerLookup);
        };
        this.params = params;
        this.container = params.container;
    }
    generateItemManager(item) {
        return new ItemManager(Object.assign(Object.assign({}, this.params), { container: this, item }));
    }
}
